/* eslint-disable */


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// material
import { styled } from '@mui/material/styles';
import {
  Box, Typography, Container,
  Table,
  Card,
  CardMedia,
  Chip,
  Stack,
  Grid,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Button,
  ToggleButtonGroup,
  ToggleButton,
  Skeleton
} from '@mui/material';
import { tableCellClasses } from '@mui/material/TableCell';


import { makeStyles } from '@mui/styles';



import { fDateTime, fDate } from '../utils/formatTime';
import { capitalizeFirstLetter, getUserAciveInactiveBasedColor } from '../utils/Utilities'
// components
import Page from '../components/Page';
import { APP_CONSTANTS } from "../URLConstants";
import { useAuth } from "../components/customContextProviders/AuthContext";
import { GetAllOrganinazations } from "../network/Organization";
import { AddUserToOrganizationModal, DeviceOrderdButtons, OrganizationMoreMenu, NewDeviceRequestFormModal, AddOrganiationBranchesModal } from "../components/_dashboard/soundbox";


const StyledTableRow = styled(TableRow)(({ _theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#F8FAFB',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#F8FAFB',
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  display: 'flex',
  minHeight: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10)
}));

const useStyles = makeStyles({

  cardWithBorder: {
    background: "#FFFFFF",
    border: " 1px solid #B0B9C7",
    boxShadow: "0px 10px 19px 1px #EAEAFF",
    boxSizing: "border-box",
    borderRadius: "20px",
    flexGrow: 1,
    overflow: 'auto',
    minHeight: '75vh',
    maxHeight: '800px',
    marginRight: "3px",
    width: "100%",
    minWidth: "100%",

  },
  backGroundRed: {
    background: "rgba(195, 10, 10, .1)"
  },
  backGroundWhite: {
    background: 'white'
  }
});




export default function Organizations() {

  const { sessionUserData } = useAuth()
  const [organizationList, setOrganizationList] = useState([]);
  const [isOrganizationListLoading, setIsOrganizationListLoading] = useState(false)
  const [isAddUserToOrganizationModalOpen, setIsAddUserToOrganizationModalOpen] = useState(false)
  const [isDeviceRequestModalOpen, setIsDeviceRequestModalOpen] = useState(false);
  const [isAddOrganizationBranchModalOpen,setIsAddOrganizationBranchModalOpen]=useState(false)

  const [selectedOrganization, setSelectedOrganization] = useState({});

  const [showTripDetails, setShowTripDetails] = useState("");
  const [dataShowMode, setDataShowMode] = useState('GRID');


  const skeltonData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]

  const classes = useStyles();

  const navigate = useNavigate()


  useEffect(() => {
    fetchOrganizations();
    return () => {
    }
  }, []);

  function fetchOrganizations() {
    setIsOrganizationListLoading(true)
    GetAllOrganinazations(1, 100).then((res) => {
      setOrganizationList(res?.data?.data)
      setIsOrganizationListLoading(false)
    }).catch((_error) => {
      setIsOrganizationListLoading(false)
    })
  }

  function onAddUserToOrganizationModalAction(d) {
    alert(d)
  }

  const handleOrganizationMoreMenuClick = (action, orgData) => {
    switch (action) {

      case "add_user": {
        setSelectedOrganization(orgData)
        setIsAddUserToOrganizationModalOpen(true)
        break;
      }
      case "view_users": {
        navigate("/dashboard/organizationusers", { state: { organizationData: orgData } })
        break
      }
      case "add_merchants": {
        setSelectedOrganization(orgData)
        setIsDeviceRequestModalOpen(true)
        break;
      }
      case "view_merchants": {
        navigate("/dashboard/merchants", { state: { organizationData: orgData } })
        break;
      }
      case "upload_organization_branch": {
        setSelectedOrganization(orgData)
        setIsAddOrganizationBranchModalOpen(true)
        break
      }

      default: {
        return
      }
    }
  }

  function onDeviceOrderedButtonsAction(action, data) {

    switch (action) {
      case APP_CONSTANTS.API_SUCCESS_ACTION: {
        fetchOrganizations()
        break;
      }
      case APP_CONSTANTS.API_FAILURE_ACTION: {
        break;
      }
      case APP_CONSTANTS.API_INPROGRESS_ACTION: {
        break;
      }
      default: {
        console.log("onCreateOrganizationModalAction", data)
      }

    }
  }

  const handleShowDataChangeVal = (event) => {
    setDataShowMode(event?.target?.value)

  }


  function onNewDeviceRequestModalAction(_d) {

  }

  return (
    <Page title="Organizations">
      <Box sx={{ pl: 3 }}>     
        <Stack direction='row' alignItems='center' >
          <DeviceOrderdButtons onAction={(d, data) => onDeviceOrderedButtonsAction(d, data)} />

          <ToggleButtonGroup
            color="primary"
            value={dataShowMode}
            exclusive
            aria-label="Platform"
            sx={{
              height: "35px",
              ml: "20px",
              mt: 2
            }}
            onChange={handleShowDataChangeVal}

          >
            <ToggleButton value="GRID">Grid</ToggleButton>
            <ToggleButton value="LIST">List</ToggleButton>
          </ToggleButtonGroup>

          {/* <Button sx={{ mt: 2,height:'5vh' }} size="small" color="whitebg" variant="contained" onClick={() => setShowTripDetails(index+"show")}>More Details</Button> */}
        </Stack>
      </Box>

      <Container maxWidth="false">
       

  
            {
              dataShowMode === 'LIST' ?
              <Card data-testid='list-org' sx={{ height: '75vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', background:'white' }}>
                  <TableContainer >
                    <Table sx={{
                      minWidth: 650,
                      '& .MuiTableRow-root.MuiTableRow-hover:hover': {
                        backgroundColor: 'rgba(145, 158, 171, .50)',
                        color: 'white'
                      }
                    }} aria-label="merchant_table">
                      <TableHead>
                        <TableRow >
                          <TableCell align="left" sx={{ fontWeight: 900, minWidth: '12vw' }}>Organization Name</TableCell>
                          <TableCell align="left" sx={{ fontWeight: 900 }}>Phone</TableCell>
                          <TableCell align="left" sx={{ fontWeight: 900 }}>Email</TableCell>

                          <TableCell align="left" sx={{ fontWeight: 900, minWidth: '12vw' }}>Address</TableCell>
                          <TableCell align="left" sx={{ fontWeight: 900 }}>Active</TableCell>
                          <TableCell align="left" sx={{ minWidth: '13vw', fontWeight: 900 }}>Onboarded Date</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>




                        {
                          isOrganizationListLoading ?

                            skeltonData.map((skelt) => (

                              <StyledTableRow
                                hover
                                key={skelt}
                                sx={{
                                  '&:last-child td, &:last-child th': { border: 0 },
                                  '& .MuiTableRow-root.MuiTableRow-hover': {
                                    backgroundColor: 'red'
                                  }
                                }}
                              >
                                <StyledTableCell component="th" scope="row">
                                  <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                  <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                  <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                  <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                  <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                  <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                                </StyledTableCell>
                                <StyledTableCell component="th" scope="row">
                                  <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
                                </StyledTableCell>
                              </StyledTableRow>

                            ))
                            :
                            null

                        }




                        {organizationList.map((organization) => (
                          <StyledTableRow
                            hover
                            key={organization?.id}
                            sx={{
                              '&:last-child td, &:last-child th': { border: 0 },
                              '& .MuiTableRow-root.MuiTableRow-hover': {
                                backgroundColor: 'red'
                              }

                            }}
                          >

                            <StyledTableCell component="th" scope="row">{organization?.name}</StyledTableCell>
                            <StyledTableCell align="left">{organization?.phone}</StyledTableCell>
                            <StyledTableCell align="left">{organization?.email}</StyledTableCell>
                            <StyledTableCell align="left">{organization?.address}</StyledTableCell>
                            <StyledTableCell align="left">{organization?.status}</StyledTableCell>
                            <StyledTableCell align="left">{fDateTime(organization?.createdAt)}</StyledTableCell>

                            <StyledTableCell align="left"> <OrganizationMoreMenu handleUser={organization} handleClicks={(e) => handleOrganizationMoreMenuClick(e, organization)} /> </StyledTableCell>
                          </StyledTableRow>
                        ))}


                      </TableBody>
                    </Table>
                  </TableContainer>
                </Card>
                :
                <Card data-testid='grid-org' sx={{ height: '75vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', p:2 }}>
              <Grid  container spacing={2} sx={{ flexGrow: 1, overflowY: 'auto', mt: 1, ml: 0.2 }}>

                  {organizationList.map((row, index) => (

                    <Grid xs={6} sm={6} md={3} mb={1} key={row?.name}>
                      <Card sx={{ maxWidth: '95%', minHeight: 280 }} >
                        {
                          row?.image !== undefined && row?.image !== null && row?.image !== 'https://example.com/image.jpg' ? <CardMedia
                            sx={{ height: 120, objectFit: 'inherit' }}
                            height="140"
                            component="img"
                            src={row?.image || "/static/icons/coming_soon.jpg"}
                            title={row?.name}

                          />
                            :
                            <Box sx={{ height: 120, backgroundColor: 'lightgray' }} />

                        }


                        {
                          row?.status !== undefined && row?.state !== null && row?.status !== '' ?
                            <Chip variant="contained" color={getUserAciveInactiveBasedColor(row?.status)} size="small" label={capitalizeFirstLetter(row?.status)} sx={{ fontSize: '12px', fontStyle: 'normal', fontWeight: 600, ml: 1, position: 'absolute', top: '2%', }} />
                            :
                            null

                        }


                        <OrganizationMoreMenu sx={{ position: 'absolute', top: '1%', right: '0%', fontWeight: 900, color: 'black' }} handleUser={row} handleClicks={(e) => handleOrganizationMoreMenuClick(e, row)} />



                        {

                          showTripDetails === index + "show" ?

                            <Box data-testid='more-details' sx={{
                              p: 2, position: 'absolute', top: '15%', width: '100%', height: '100%', backgroundColor: '#F8FAFB',
                              boxShadow: '0 0 10px rgba(1, 1, 0, 0.5)'
                            }}>
                              <Typography sx={{ fontSize: 16, fontWeight: 700, color: '#171D40' }}>
                                {row?.name}
                              </Typography>
                              <Typography sx={{ fontSize: 12, fontWeight: 700, lineHeight: '20px', color: '#6F6F6F' }}>
                                Date Created - {fDate(row?.createdAt)}
                              </Typography>
                              <Typography sx={{ fontSize: 12, fontWeight: 700, lineHeight: '20px', color: '#6F6F6F' }}>
                                Email - {row?.email}
                              </Typography>
                              <Typography sx={{ fontSize: 12, fontWeight: 700, lineHeight: '20px', color: '#6F6F6F' }}>
                                Mobile - {row?.phone}
                              </Typography>

                              <Typography sx={{ fontSize: 12, fontWeight: 700, lineHeight: '20px', color: '#6F6F6F' }}>
                                Address - {row?.address}
                              </Typography>

                              <Button size="small" sx={{ mt: 2 }} variant="outlined" onClick={() => setShowTripDetails(index + "hide")}>Less Details</Button>

                            </Box>

                            :
                            <Box data-testid='less-details' sx={{ p: 2 }}>
                              <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#171D40' }}>
                                {row?.name}
                              </Typography>

                              <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#6F6F6F' }}> {row?.address} </Typography>


                              {/* <Stack direction='row' spacing={1}>
                          <Typography sx={{ fontSize: 12, fontWeight: 600, color: '#6F6F6F' }}> Date Created  </Typography>
                          <Typography sx={{ fontSize: 14, fontWeight: 800, color: '#6F6F6F' }}>  {fDate(row?.createdAt)} </Typography>
                          </Stack> */}


                              <Button sx={{ mt: 2, position: 'absolute', bottom: '10px' }} size="small" variant="outlined" onClick={() => setShowTripDetails(index + "show")}>More Details</Button>
                            </Box>

                        }

                      </Card>
                    </Grid>
                  ))}

                </Grid>
                </Card>

            }

      </Container>

      <AddUserToOrganizationModal organizationData={selectedOrganization} opneAssignedModal={isAddUserToOrganizationModalOpen} handleClose={() => setIsAddUserToOrganizationModalOpen(false)} onAction={(d) => onAddUserToOrganizationModalAction(d)} />
      <NewDeviceRequestFormModal organizationData={selectedOrganization} opneAssignedModal={isDeviceRequestModalOpen} handleClose={() => setIsDeviceRequestModalOpen(false)} onAction={(d) => onNewDeviceRequestModalAction(d)} />
      <AddOrganiationBranchesModal organizationData={selectedOrganization} opneAssignedModal={isAddOrganizationBranchModalOpen} handleClose={() => setIsAddOrganizationBranchModalOpen(false)}  />

    </Page>
  );
}
